import React, { lazy, Suspense } from 'react';
import LocalShipping from '@mui/icons-material/LocalShipping';
import { Loading } from 'react-admin';

// Lazily import the components
const List = lazy(() => import('./List'));
const Create = lazy(() => import('./Create'));
const Edit = lazy(() => import('./Edit'));

// Define a component to handle the loading fallback
const Loader = () => <Loading />;

const conf = {
    name: 'lil_drug_broker',
    icon: <LocalShipping />,
    list: () => (
        <Suspense fallback={<Loader />}>
            <List />
        </Suspense>
    ),
    create: () => (
        <Suspense fallback={<Loader />}>
            <Create />
        </Suspense>
    ),
    edit: () => (
        <Suspense fallback={<Loader />}>
            <Edit />
        </Suspense>
    ),
    // show: ShowGuesser, // Uncomment or modify this line as needed
    options: {
        label: "Broker",
        items: true
    }
};

export default conf;
